export enum PhoneTypesEnum {
        Home = 2135,
        Cell = 2136,
        Work = 2137,
        Other = 2138,
}
